const VERSION = '1.2.0';

const GROUP_TYPE = {
    GROUP_MEMBERS: 0,
    GROUP_MOBILES: 1,
}

const SENT_VIA = [
    "",
    "Site",
    "Flex",
    "API",
    "App",
    "IMS",
]

export {
    VERSION,
    GROUP_TYPE,
    SENT_VIA,
}
